export default __webpack_public_path__ + "static/media/instagram.35345759.svg";